import styled from 'styled-components'

const TipsStyle = styled.div`
	--tipsTitleAndArrowsWrapMargin: var(--sp8x) 0 var(--sp4x) 0;
	--sliderButtonSizes: var(--sp5x);
	--sliderPrevButtonMarginRight: var(--sp7x);

	--iconCircleSizes: var(--sp12x);
	--iconSizes: var(--sp5x);
	--slidePadding: var(--sp6x) var(--sp4x);
	--slideTextMarginTop: var(--sp6x);
	--swiperSliderPadding: var(--sp3x);
	--slideBorderRadius: var(--sp4x);
	--slideBorder: var(--sp0-5x);

	.title-and-arrows-wrap {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin: var(--tipsTitleAndArrowsWrapMargin);

        .arrows-wrap {
            display: flex;
            align-items: center;
        }

		.top-thing-title {
			max-width: var(--topThingsTitleMaxWidth);
		}

		.arrows-wrap {
			.slider-button {
				display: inline-block;
				font-size: var(--sliderButtonSizes);
				cursor: pointer;

				&.swiper-button-disabled {
					color: var(--secondaryColor4);
					pointer-events: none;
				}

				&.slider-tips-prev-button {
					transform: rotate(180deg);
					margin-right: var(--sliderPrevButtonMarginRight);
				}
			}
		}
	}

	.tips-slider {
		margin: 0 calc(var(--swiperSliderPadding) * -1);

		.swiper-slide {
			padding: 0 var(--swiperSliderPadding);
			height: unset;

			.slide {
				display: flex;
				flex-direction: column;
				align-items: center;
				text-align: center;
				padding: var(--slidePadding);
				border: var(--slideBorder) solid var(--primaryColor3);
				border-radius: var(--slideBorderRadius);
				height: 100%;

				.slide-text {
					margin-top: var(--slideTextMarginTop);
				}

				.icon-wrap {
					width: var(--iconCircleSizes);
					height: var(--iconCircleSizes);
					display: flex;
					justify-content: center;
					align-items: center;
					background-color: var(--primaryColor3);
					border-radius: 50%;

					.tips-slide-icon {
						width: var(--iconSizes);
						height: var(--iconSizes);
					}
				}
			}
		}
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeL}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXLMin}) {
		--tipsTitleAndArrowsWrapMargin: var(--sp7x) 0 var(--sp3x) 0;
		--sliderButtonSizes: var(--sp4x);
		--sliderPrevButtonMarginRight: var(--sp5x);

		--iconCircleSizes: var(--sp8x);
		--iconSizes: var(--sp3x);
		--slidePadding: var(--sp5x) var(--sp2-5x);
		--slideTextMarginTop: var(--sp5x);
		--swiperSliderPadding: var(--sp2-5x);
		--slideBorderRadius: var(--sp3x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeM}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeLMin}) {
		--tipsTitleAndArrowsWrapMargin: var(--sp6x) 0 var(--sp3x) 0;
		--sliderButtonSizes: var(--sp3x);
		--sliderPrevButtonMarginRight: var(--sp5x);

		--iconCircleSizes: var(--sp7x);
		--iconSizes: var(--sp2-5x);
		--slidePadding: var(--sp4x) var(--sp2x);
		--slideTextMarginTop: var(--sp4x);
		--swiperSliderPadding: var(--sp2x);
		--slideBorderRadius: var(--sp2-5x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeS}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeMMin}) {
		--tipsTitleAndArrowsWrapMargin: var(--sp6x) 0 var(--sp3x) 0;
		--sliderButtonSizes: var(--sp3x);
		--sliderPrevButtonMarginRight: var(--sp5x);

		--iconCircleSizes: var(--sp7x);
		--iconSizes: var(--sp2-5x);
		--slidePadding: var(--sp4x) var(--sp2x);
		--slideTextMarginTop: var(--sp4x);
		--swiperSliderPadding: var(--sp2x);
		--slideBorderRadius: var(--sp2-5x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXS}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeSMin}) {
		--tipsTitleAndArrowsWrapMargin: var(--sp5x) 0 var(--sp2x) 0;
		--sliderButtonSizes: var(--sp2-5x);
		--sliderPrevButtonMarginRight: var(--sp4x);

		--iconCircleSizes: var(--sp7x);
		--iconSizes: var(--sp2-5x);
		--slidePadding: var(--sp4x) var(--sp2x);
		--slideTextMarginTop: var(--sp4x);
		--swiperSliderPadding: var(--sp2x);
		--slideBorderRadius: var(--sp2-5x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.TabletSize}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXSMin}) {
		--tipsTitleAndArrowsWrapMargin: var(--sp4x) 0 var(--sp2x) 0;
		--sliderButtonSizes: var(--sp2-5x);
		--sliderPrevButtonMarginRight: var(--sp3x);

		--iconCircleSizes: var(--sp7x);
		--iconSizes: var(--sp2-5x);
		--slidePadding: var(--sp4x) var(--sp2x);
		--slideTextMarginTop: var(--sp4x);
		--swiperSliderPadding: var(--sp2x);
		--slideBorderRadius: var(--sp2-5x);
		--slideBorder: 3px;
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.TabletSizeS}) and (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeMin}) {
		--tipsTitleAndArrowsWrapMargin: var(--sp4x) 0 var(--sp2x) 0;
		--sliderButtonSizes: var(--sp2-5x);
		--sliderPrevButtonMarginRight: var(--sp3x);

		--iconCircleSizes: var(--sp7x);
		--iconSizes: var(--sp2-5x);
		--slidePadding: var(--sp4x) var(--sp2x);
		--slideTextMarginTop: var(--sp4x);
		--swiperSliderPadding: var(--sp2x);
		--slideBorderRadius: var(--sp2-5x);
		--slideBorder: 3px;
	}

	@media (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeSMin}) {
		--tipsTitleAndArrowsWrapMargin: var(--sp4x) 0 var(--sp2x) 0;
		--sliderButtonSizes: var(--sp2x);
		--sliderPrevButtonMarginRight: var(--sp2-5x);

		--iconCircleSizes: var(--sp7x);
		--iconSizes: var(--sp2-5x);
		--slidePadding: var(--sp4x) var(--sp2x);
		--slideTextMarginTop: var(--sp4x);
		--swiperSliderPadding: 0;
		--slideBorderRadius: var(--sp2-5x);
		--slideBorder: 3px;
	}
`

export default TipsStyle
